
import { useDocumentIssuanceTracked } from "presentation/store/DocumentIssuance/DocumentIssuanceProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import { DocumentIssuanceEditPanel } from "./DocumentIssuanceEditPanel";
import DocumentIssuanceMaintenance from "./DocumentIssuanceMaintenance";
import { DocumentIssuanceHeaderFormPanel } from "./Form/DocumentIssuanceHeaderFormPanel";


export const DocumentIssuanceMasterView: React.FC = () => {
    const [docIssuanceState] = useDocumentIssuanceTracked();

    const { isAdd, isEditable, isSliderOpen } = docIssuanceState.masterState;

    return <>
        <div className="main-comp-wrapper">
            <DocumentIssuanceMaintenance />
            {
                ((isAdd || isEditable) &&
                    <SliderPanel
                        isOpen={isSliderOpen}
                        leftSectionWidth={"55%"}
                        rightSectionWidth={"45%"}
                        leftChildren={<DocumentIssuanceHeaderFormPanel />}
                        rightChildren={<DocumentIssuanceEditPanel />}
                    />
                )
            }
        </div>
    </>
}